<template>
  <div
    class="db-funnel-results-list db-results-wrapper-venue"
    :class="`db-results-wrapper-${
      nbrGridLayout === 2
        ? isMobile
          ? 3
          : 2
        : nbrGridLayout === 1 || nbrGridLayout === 3
        ? nbrGridLayout
        : 'none'
    }`"
  >
    <div
      v-for="venue in venues"
      :key="venue.id"
    >
      <DbCard class="db-tw-h-full">
        <template v-slot:illustration>
          <DbCardIllustration
            v-if="venue.photos"
            :title="venue.name"
            :photos="venue.photos"
          />
        </template>
        <template v-slot:content>
          <DbCardContentVenue
            :showRoomAttributes="showRoomAttributes"
            v-on:click-details="$emit('click-details', venue)"
            v-on:select-item="$emit('select-venue', venue)"
          >
            <template v-slot:title>
              {{ venue.name }}
            </template>
            <template
              v-slot:dimensions
              v-if="
                venue.total_area &&
                venue.total_area.length !== 0 &&
                venue.total_area !== '0.00' &&
                venue.total_area !== '0'
              "
            >
              {{ venue.total_area }} {{ $t('sqm.') }}
            </template>
            <template
              v-slot:capacity
              v-if="venue.max_capacity"
            >
              {{ venue.max_capacity }}</template
            >
            <template
              v-slot:description
              v-if="
                venue.short_description &&
                getDescription(venue.short_description) &&
                getDescription(venue.short_description)?.length !== 0
              "
            >
              <!-- eslint-disable-next-line vue/no-v-html -->
              <div
                class="db-wysiwyg"
                v-html="getDescription(venue.short_description)"
              />
            </template>
            <template
              v-if="showRoomAmenities && venue.meeting_room_amenities.length"
              v-slot:amenities
            >
              <!-- Icons Amenities -->
              <DbListDetailsIcons
                class="db-card-list-amenities"
                :listLength="venue.meeting_room_amenities.length"
              >
                <template v-slot:tooltiplabel="{ index }">
                  {{ venue.meeting_room_amenities[index].name }}
                </template>
                <template v-slot:icon="{ index }">
                  <img
                    class="db-card-amenities-item-icon"
                    :src="venue.meeting_room_amenities[index].url"
                    width="22"
                    alt=""
                  />
                  <span class="db-card-amenities-item-label">
                    {{ venue.meeting_room_amenities[index].name }}
                  </span>
                </template>
              </DbListDetailsIcons>
            </template>
            <template
              v-if="venue.displayPrice"
              v-slot:rate
            >
              <DbRate class="db-card-rate db-text-right db-tw-mb-4">
                <template v-slot:prefix> </template>
                <template v-slot:rate>
                  <PriceDisplay
                    v-if="venue.displayPrice"
                    :value="
                      seeTotalPrice ? venue.displayPrice.valueTotal() : venue.displayPrice.value
                    "
                    :currencyCode="venue.displayPrice.currencyCode"
                  />
                </template>
                <template
                  v-if="nbrGridLayout !== 1"
                  v-slot:suffix
                >
                  {{ seeTotalPrice ? $t('Total per day') : $t('Per person/day') }}
                </template>
                <template
                  v-else
                  v-slot:details
                >
                  {{ seeTotalPrice ? $t('Total per day') : $t('Per person/day') }}
                </template>
                <template
                  v-slot:footernote
                  v-if="venue.taxes == 'inclusive'"
                >
                  {{ $t('Inclusive of taxes and fees') }}
                </template>
                <template
                  v-slot:footernote
                  v-else-if="venue.taxes == 'exclusive'"
                >
                  {{ $t('Exclusive of taxes and fees') }}
                </template>
                <template
                  v-slot:footernote
                  v-else-if="venue.taxes == 'subject'"
                >
                  {{ $t('Subject to additional taxes and fees') }}
                </template>
              </DbRate>
            </template>
          </DbCardContentVenue>
        </template>
      </DbCard>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useHtmlTruncate } from '@/composables/useHtmlTruncate'
import type { SearchVenue } from '@/pages/booking-funnel/types/SearchVenue'
import type { DescriptionFormat } from '@/types/galaxy-data/unit'
import { useBreakpoints } from '@vueuse/core'

const props = withDefaults(
  defineProps<{
    venues: SearchVenue[]
    descriptionDisplay?: DescriptionFormat
    seeTotalPrice: boolean
    showRoomAmenities?: boolean
    showRoomAttributes?: boolean
    nbrGridLayout?: number
  }>(),
  {
    nbrGridLayout: 1,
  },
)

defineEmits<{
  (e: 'click-details', venue: SearchVenue): void
  (e: 'select-venue', venue: SearchVenue): void
}>()

// TODO: duplicated
function getDescription(desc: string) {
  if (props.descriptionDisplay) {
    switch (props.descriptionDisplay) {
      case 'none':
        return null
      case 'truncate':
        return useHtmlTruncate(desc)
      case 'full':
        return desc
    }
  }
  return desc
}

const breakpoints = useBreakpoints({ mobile: 992 })
const isMobile = breakpoints.smaller('mobile')
</script>

<style>
.db-app .db-card-list-amenities {
  display: flex !important;
  flex-wrap: wrap !important;
  row-gap: var(--db-spacer-12) !important;
  column-gap: var(--db-spacer-14) !important;
}

.db-app .db-card-list-amenities .db-list-details-icons-item {
  min-height: max-content !important;
  height: max-content !important;
}

.db-app .db-card-list-amenities .db-card-amenities-item-icon {
  color: var(--db_iconography_color);
  margin-right: var(--db-spacer-8);
}

.db-app .db-card-list-amenities .db-card-amenities-item-label {
  font-family: var(--db_body_text_font_family);
  font-size: var(--db-font-size-12);
  font-weight: 500;
  color: var(--db_iconography_color);
  vertical-align: middle;
}

/** 3 on 1 line */
.db-app .db-funnel-results-list.db-results-wrapper-3 {
  grid-template-columns: repeat(3, minmax(300px, 1fr));
}

/** 2 on 1 line */
.db-app .db-funnel-results-list.db-results-wrapper-2 {
  grid-template-columns: repeat(2, minmax(300px, 1fr));
}

/** 1 on 1 line */
.db-app .db-funnel-results-list.db-results-wrapper-1,
.db-app .db-funnel-results-list.db-results-wrapper- {
  grid-template-columns: 1fr;
}

/** On mobile, put 1 on line */
@media screen and (max-width: 680px) {
  .db-app .db-funnel-results-list.db-results-wrapper-3 {
    grid-template-columns: minmax(300px, 1fr);
  }
  .db-app .db-funnel-results-list.db-results-wrapper-2 {
    grid-template-columns: minmax(300px, 1fr);
  }
}

/** On tablet, force put 1 -> 2 on 1 line */
@media (min-width: 680px) and (max-width: 992px) {
  .db-app .db-funnel-results-list.db-results-wrapper-3 {
    grid-template-columns: repeat(2, minmax(300px, 1fr));
  }
}
</style>
